export default __webpack_public_path__ + "static/media/screen-7.ccfc8ab1.jpg";